'use strict';

var icons = require('./source/components/icons/icons');
var ferrous = icons;

module.exports = ferrous;



//////////////////
// WEBPACK FOOTER
// ./~/ferrous/index.js
// module id = 511
// module chunks = 1 4